{
    "_s1TQ0hfp-B92SzFP8L-x": {
        "key": "_s1TQ0hfp-B92SzFP8L-x",
        "position": {
            "x": 16,
            "y": 11,
            "z": 1
        },
        "tag": "spawn"
    },
    "_4gUu6tRDCXr5w3_fhM8H": {
        "key": "_4gUu6tRDCXr5w3_fhM8H",
        "position": {
            "x": 17,
            "y": 11,
            "z": 1
        },
        "tag": "spawn"
    },
    "2dg9XiJhybS7yn_DoRmjn": {
        "key": "2dg9XiJhybS7yn_DoRmjn",
        "position": {
            "x": 18,
            "y": 12,
            "z": 1
        },
        "tag": "spawn"
    },
    "XWMbcK8X2znj_2M6HPjOM": {
        "key": "XWMbcK8X2znj_2M6HPjOM",
        "position": {
            "x": 18,
            "y": 13,
            "z": 1
        },
        "tag": "spawn"
    },
    "XHJxSZjzHSd0T-_HZtzfA": {
        "key": "XHJxSZjzHSd0T-_HZtzfA",
        "position": {
            "x": 18,
            "y": 15,
            "z": 1
        },
        "tag": "spawn"
    },
    "qSuPkmnyBURJWRSYx5jsD": {
        "key": "qSuPkmnyBURJWRSYx5jsD",
        "position": {
            "x": 18,
            "y": 14,
            "z": 1
        },
        "tag": "spawn"
    },
    "pcUVvyEtU4OoY3nqk6oAb": {
        "key": "pcUVvyEtU4OoY3nqk6oAb",
        "position": {
            "x": 18,
            "y": 16,
            "z": 1
        },
        "tag": "spawn"
    },
    "ACeDHBIyMJvyrLbfE2OSR": {
        "key": "ACeDHBIyMJvyrLbfE2OSR",
        "position": {
            "x": 18,
            "y": 17,
            "z": 1
        },
        "tag": "spawn"
    },
    "_-MiEyxbNoKa5fX-_Cdk2": {
        "key": "_-MiEyxbNoKa5fX-_Cdk2",
        "position": {
            "x": 16,
            "y": 18,
            "z": 1
        },
        "tag": "spawn"
    },
    "cZnjO5f2D-O5tHHIgTmOR": {
        "key": "cZnjO5f2D-O5tHHIgTmOR",
        "position": {
            "x": 17,
            "y": 18,
            "z": 1
        },
        "tag": "spawn"
    },
    "kaIiflCeCc_3YQbCAzh6k": {
        "key": "kaIiflCeCc_3YQbCAzh6k",
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "tag": "spawn"
    },
    "y1BogZ77OhqpUwIqHjt9r": {
        "key": "y1BogZ77OhqpUwIqHjt9r",
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "tag": "spawn"
    },
    "WcENfxIuee6I5YYIaKhMD": {
        "key": "WcENfxIuee6I5YYIaKhMD",
        "position": {
            "x": 13,
            "y": 18,
            "z": 1
        },
        "tag": "spawn"
    },
    "k7rYi1t2lBT2krygPvRZn": {
        "key": "k7rYi1t2lBT2krygPvRZn",
        "position": {
            "x": 11,
            "y": 16,
            "z": 1
        },
        "tag": "spawn"
    },
    "BVLFW7_VvSC4iY2_Wl7SC": {
        "key": "BVLFW7_VvSC4iY2_Wl7SC",
        "position": {
            "x": 12,
            "y": 18,
            "z": 1
        },
        "tag": "spawn"
    },
    "oDhYo3dI0BGvcryBXwVeL": {
        "key": "oDhYo3dI0BGvcryBXwVeL",
        "position": {
            "x": 11,
            "y": 17,
            "z": 1
        },
        "tag": "spawn"
    },
    "glitlUKH5eA3cBkldDsQg": {
        "key": "glitlUKH5eA3cBkldDsQg",
        "position": {
            "x": 11,
            "y": 15,
            "z": 1
        },
        "tag": "spawn"
    },
    "z25cngzks_BGm7AvZebOx": {
        "key": "z25cngzks_BGm7AvZebOx",
        "position": {
            "x": 11,
            "y": 13,
            "z": 1
        },
        "tag": "spawn"
    },
    "UiOSR07fdtM6mG-WbGSk0": {
        "key": "UiOSR07fdtM6mG-WbGSk0",
        "position": {
            "x": 11,
            "y": 14,
            "z": 1
        },
        "tag": "spawn"
    },
    "UkM0Kj6oIBXsi1qmpqTOw": {
        "key": "UkM0Kj6oIBXsi1qmpqTOw",
        "position": {
            "x": 11,
            "y": 12,
            "z": 1
        },
        "tag": "spawn"
    },
    "CohkNGT6azbpDd6hPJnbz": {
        "key": "CohkNGT6azbpDd6hPJnbz",
        "position": {
            "x": 12,
            "y": 11,
            "z": 1
        },
        "tag": "spawn"
    },
    "epxYIpx-ZavfthVFb0xhT": {
        "key": "epxYIpx-ZavfthVFb0xhT",
        "position": {
            "x": 14,
            "y": 11,
            "z": 1
        },
        "tag": "spawn"
    },
    "0n0XkXTm8oY6oJ3gIbTX5": {
        "key": "0n0XkXTm8oY6oJ3gIbTX5",
        "position": {
            "x": 13,
            "y": 11,
            "z": 1
        },
        "tag": "spawn"
    },
    "2htqrXDrJfH1yLKWtD_FU": {
        "key": "2htqrXDrJfH1yLKWtD_FU",
        "position": {
            "x": 15,
            "y": 11,
            "z": 1
        },
        "tag": "spawn"
    },
    "HyDhCA9xY8X3dWRm0VP8-": {
        "key": "HyDhCA9xY8X3dWRm0VP8-",
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "M_T6RXBREtofAVKnqYO4y": {
        "key": "M_T6RXBREtofAVKnqYO4y",
        "position": {
            "x": 14,
            "y": 15,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "gPeVeuC4tug2GytNenwOx": {
        "key": "gPeVeuC4tug2GytNenwOx",
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "f-f3TTSNd_E2FC0FTlfra": {
        "key": "f-f3TTSNd_E2FC0FTlfra",
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    }
}